import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class ConsigneeService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private httpClient: HttpClient, private errorHandler: ConfigErrorHandler) { }

  /**
   * Get All Consignees
   * @returns Array
   */
  public getAllConsignees():Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/consignees`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Create new consignee
   * @param formData
   * @returns array
   */
  saveConsignee(formData:any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/consignees`;

    return this.httpClient.post(apiURL,formData, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get consignee for editing
   * @returns Array
   */
  edit(id:string){

    let apiURL:string=`${this.baseURL}/v1/consignees/${id}/edit`;

    return this.httpClient.get(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Update consignee
   * @param formData
   * @param Id
   * @returns array
   */
  update(formData:any,Id: string|null):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/consignees/${Id}`;

    const post_data = {
      country_id: formData.country_id,
      consignee_name: formData.consignee_name,
    };

    return this.httpClient.put(apiURL,post_data, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Delete  consignee
   * @param consigneeId
   * @returns array
   */
    delete(consigneeId: string|null):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/consignees/${consigneeId}`;

    return this.httpClient.delete(apiURL, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
